import React from "react";
import { Box } from "@mui/material";
import { ItemType } from "../../types/types";
import ImageCarousel from "./ImageCarousel";
import { collectItemImages } from "./itemImages";

/**
 * Whether a product has anything to show in the gallery.
 *
 * Lives beside the gallery rather than in `Item.tsx` because two things have to agree on the
 * answer: this component rendering, and the layout grid collapsing to a single column when it
 * doesn't.
 */
export const hasItemImages = (item: ItemType) => collectItemImages(item).length > 0;

type ItemGalleryProps = {
  item: ItemType;
  variant: "desktop" | "mobile";
};

/**
 * The product images (EB-537).
 *
 * The mobile variant used to carry an "Imágenes:" heading. A carousel that occupies one screenful
 * and announces its own position does not need a label telling the reader that photos are photos.
 */
const ItemGallery: React.FC<ItemGalleryProps> = ({ item, variant }) => {
  if (!hasItemImages(item)) return null;

  return (
    <Box px={2} py={variant === "mobile" ? 0 : 2}>
      <ImageCarousel item={item} showThumbnails={variant === "desktop"} />
    </Box>
  );
};

export default ItemGallery;
